let versionArr=[
	{
		time:'2022/12/16',
		version:'2.5.06',
		li:[
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'新增第一个审批流节点为多人审批时，可申请人在申请用章界面自选审批人'
			}
		]
	},
	{
		time:'2022/12/06',
		version:'2.5.05',
		li:[
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'图片查看时enSave增加2为明文传输'
			}
		]
	},
	{
		time:'2022/12/01',
		version:'2.5.04',
		li:[
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'【我的申请、审批授权审计处理】-->增加用印视频，视频组件支持单个和多个视频播放'
			},
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'【电子围栏】-->修复搜索地址无数据问题'
			},
		]
	},
	{
		time:'2022/11/30',
		version:'2.5.03',
		li:[
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'【我的申请、审批授权审计处理】-->数据表格操作中添加用印记录，并去除查看中的使用记录'
			},
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'【我的申请、审批授权审计处理】查看详情中，直接显示审批流程，无需再次点击查看'
			},
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'【用印记录】表格中图片显示第一张，多了显示角标，点击查看图片增加图片描述信息如【申请单标题、用印模式、图片类型、用印时间、用印次数、图片序号】'
			},
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'【组织管理-->人员管理】表格增加登录名显示'
			},
		]
	},
	{
		time:'2022/10/22',
		version:'2.5.02',
		li:[
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'附件查看-->增加在线预览功能'
			},
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'首页-->增加电子印章快捷入口（去除左侧菜单入口）'
			},
		]
	},
	{
		time:'2022/9/26',
		version:'2.5.01',
		li:[
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'审批处理-->修复归档处理的申请日期和归档日期颠倒问题'
			},
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'数据监控-->修复地图不展示问题'
			},
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'使用记录-->查看视频，标题显示 x次~x次视频'
			},
		]
	},
	{
		time:'2022/9/21',
		version:'2.5.00',
		li:[
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'设备管理-->增加门禁管理'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'数据监控-->增加门禁记录'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'平台管理-->增加租户管理'
			},
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'审批管理-->审计处理、审批处理、授权处理的状态显示问题'
			},
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'数据监控-->图文搜索展示时闪一下问题'
			}
		]
	},
	{
		time:'2022/9/16',
		version:'2.4.99',
		li:[
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'审批管理-->增加归档处理'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'组织架构-->人员管理-->增加人员导入功能（及按钮权限）'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'数据监控-->增加图文搜索'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'用印中心-->增加查看视频'
			},
		]
	},
	{
		time:'2022/9/09',
		version:'2.4.98',
		li:[
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'审批管理-->识别对比-->默认展示数据问题'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'登录页面动态增加企业微信登录方式'
			},
		]
	},
	{
		time:'2022/9/02',
		version:'2.4.97',
		li:[
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'登录、注册、重置页面改成云玺设计页面'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'系统管理-->申请类型-->增加默认解锁'
			},
		]
	},
	{
		time:'2022/8/30',
		version:'2.4.96',
		li:[
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'平台管理-->印控台配置-->迁移显示问题'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'首页-->地图新增全屏功能'
			},
		]
	},
  {
  	time:'2022/8/17',
  	version:'2.4.95',
  	li:[
  		{
  			type:'',//success/''/warning||新增/优化/修复
  			typeInfo:'优化',
  			text:'印章柜-->印章入柜-->印章柜成功添加或删除印章后，印章柜列表立即回显数据'
  		},
  		{
  			type:'',//success/''/warning||新增/优化/修复
  			typeInfo:'优化',
  			text:'印章柜-->存取记录-->存取记录列表时间字段显示在首列'
  		},
      {
      	type:'',//success/''/warning||新增/优化/修复
      	typeInfo:'优化',
      	text:'印章柜-->柜体监控-->优化前端页面布局，解决字体出现重叠问题.'
      },
      {
      	type:'warning',//success/''/warning||新增/优化/修复
      	typeInfo:'修复',
      	text:'印章柜-->存储记录-->解决印章名称显示问题'
      },
      {
      	type:'',//success/''/warning||新增/优化/修复
      	typeInfo:'优化',
      	text:'印章柜-->印章柜列表-->添加/编辑印章柜-->实现检测按钮检测人脸设备IP和读写设备IP是否有效的功能。'
      },

  	]
  },
	{
		time:'2022/7/27',
		version:'2.4.95',
		li:[
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'新增OA跳转界面查看【申请单详情】地址为http://xxxx/yxkj/jumpApplicationInfo?userId=6895'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'新增OA跳转界面查看【设备列表】地址为http://xxxx/yxkj/jumpDeviceList?userId=6895'
			},
		]
	},
	{
		time:'2022/7/23',
		version:'2.4.94',
		li:[
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'关闭中通服印签系统网页，再输入错误的登录URL会自动跳转到印签系统首页'
			},
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'组织管理-->人员管理-->编辑或添加时手机号码可以为空'
			},
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'平台管理-->对接应用管理-->优化事件名称和事件类型的逻辑'
			},
		]
	},
	{
		time:'2022/7/13',
		version:'2.4.93',
		li:[
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'识别对比-->查看详情-->优化弹出框高度自适应'
			},
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'申请类型-->添加或编辑-->盖章拍照默认开启，开启后才出现相应配置'
			},
		]
	},
	{
		time:'2022/7/12',
		version:'2.4.92',
		li:[
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'登录成功切换到当前账号所属组织的路由编码URL'
			},
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'登录业务逻辑-->密码登录、验证码登录、双因子登录（前端固定排序）'
			},
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'若某条人脸记录已有备注，点击备注应显示出备注内容。'
			},
		]
	},
		{
			time:'2022/7/11',
			version:'2.4.91',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'系统管理-->申请类型-->添加-->去除赋码大小'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'审批管理-->识别对比-->刚进入默认选择第一个申请单'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'对标签页关闭全部，网址会变成xxxx.xxx.xxx.xxx/yxkj/xxxx'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'远程控制-->电子围栏-->修复已添加的电子围栏无法删除问题'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'印章管理-->人脸记录-->备注-->修复备注无法清空问题（非必填）'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'个人信息中增加当前web系统的版本号'
				},

			]
		},
		{
			time:'2022/6/06',
			version:'2.4.90',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'平台管理-->新增系统运行日志'
				},
			]
		},
		{
			time:'2022/5/31',
			version:'2.4.89',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'印章管理-->申请导出功能无法使用问题'
				},
			]
		},
		{
			time:'2022/5/26',
			version:'2.4.88',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'电子围栏-->编辑时-->增加文本复制，地图回显坐标位置，半径描述性文字'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'用印中心-->使用记录-->时间搜索失败的问题'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'印章管理-->指纹信息-->搜索后表格未更新的问题'
				},
			]
		},
		{
			time:'2022/5/20',
			version:'2.4.87',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'优化首页地图及电子围栏地图展示缺失区域问题'
				},
			]
		},
		{
			time:'2022/5/18',
			version:'2.4.86',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'远程管理-->电子围栏，百度地图经纬度默认转高德经纬度'
				},
			]
		},
		{
			time:'2022/5/14',
			version:'2.4.85',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'系统管理-->远程控制-->新增【电子围栏】编辑、添加、删除功能'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'设备管理-->新增【印控台管理】编辑、解绑、绑定功能'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'平台管理-->新增【印控台配置】迁移功能'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'平台管理-->新增【系统属性配置】功能，如申请单过期时间，授权码失效时间'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:`组织架构-->【组织管理，角色管理，人员管理】新增按钮级别权限控制 </br>
						系统管理-->【远程控制】新增按钮级别权限控制</br>
						设备管理-->【印章管理】新增按钮级别权限控制
					`
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'平台管理-->OCR配置管理-->租户列表-->新增搜索功能'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'审批管理-->智能ocr-->当没有ocr数据时表格并未更新的问题'
				},
			]
		},
		{
			time:'2022/5/09',
			version:'2.4.84',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'电子印签-->使用记录-->搜索关键词增加【申请单名称搜索】'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'【合同标题，合同名称，用章文件名，申请标题】-->统一改为申请单名称'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复电子印签-->合同管理-->提取合同-->每次提取，提取码自动在输入框内'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复切换公司时对应的按钮级别权限未改变'
				},
			]
		},
		{
			time:'2022/5/07',
			version:'2.4.83',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'新增视频记录中【用印人，用印模式】字段'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复我的申请-->查看【申请详情】-->查看使用记录-->量子图片不展示问题'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'优化人脸记录展示界面'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'优化视频播放展示界面'
				},
			]
		},
		{
			time:'2022/5/06',
			version:'2.4.82',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'电子印章-->添加-->审计员必填项，前面加*'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复印章管理-->人脸记录-->备注问题'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'平台管理-->缴费配置-->业务服务器配置可搜索'
				},
			]
		},
		{
			time:'2022/5/05',
			version:'2.4.81',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'添加经办人修改为添加印章管理员'
				},
			]
		},
		{
			time:'2022/4/27',
			version:'2.4.80',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复电子印章附件预览没有盖章'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复系统管理-->远程控制-->点击指纹模式【提示设备不存在问题】'
				},
			]
		},
		{
			time:'2022/4/26',
			version:'2.4.77',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'绘制电子印章时 印章类型选择自定义后才可编辑--服务端已支持'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'远程控制-->增加ocr识别功能开关，修改UI显示界面'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'创建合同-->向签名人发送签署链接建议默认改为选中'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'签署合同时一页可盖多个电子印章【重要】（需重点测试）'
				},
			]
		},
		{
			time:'2022/4/24',
			version:'2.4.76',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'自定义绘制电子章下拉类型可编辑'
				},
			]
		},
		{
			time:'2022/4/22',
			version:'2.4.75',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'”智能印章终端授权“改成“智能印章设备授权”'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'提交审计时，审批管理---审计处理角标显示失败'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'在电子印章使用记录详情中，添加合同名称字段。'
				},
			]
		},
		{
			time:'2022/4/21',
			version:'2.4.74',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复授权结束后提示框不会自动关闭'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复PDF解析失败问题'
				},
			]
		},
		{
			time:'2022/4/14',
			version:'2.4.72',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'',
					text:'新增app升级中心'
				},
			]
		},
		{
			time:'2022/3/29',
			version:'2.4.68',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'',
					text:'新增国科解密'
				},
			]
		},
		{
			time:'2022/3/22',
			version:'2.4.64',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'',
					text:'新增wifi加密方式'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复若干bug'
				},
			]
		},
		{
			time:'2022/3/22',
			version:'2.4.63',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'',
					text:'新增电子印签的按钮权限'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复若干bug(修复视频列表未做分页处理)'
				},
			]
		},
		{
			time:'2022/3/11',
			version:'2.4.62',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复pdf打开报错问题，修复盖章次数不统一，修复部门不能申请电子章等问题'
				},
			]
		},
		{
			time:'2022/3/10',
			version:'2.4.61',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复接口拼接问题'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'新增电子印签功能'
				},
			]
		},
		{
			time:'2022/2/18',
			version:'2.4.6',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'公司属主姓名修改后，公司信息栏未同步属主姓名。'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'设备管理-印章管理-连接无密码wifi时，印签管理后台不输入wifi密码提示错误信息（线上服务器）'
				},
			]
		},
		{
			time:'2022/1/06',
			version:'2.4.5',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'更新隐私政策'
				},
			]
		},
		{
			time:'2021/5/12',
			version:'2.4.4',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复若干bug'
				},
			]
		},
		{
			time:'2021/4/21',
			version:'2.4.3',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'删除员工时获取到指纹list不存在时出现的问题'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复用户无token的情况直接进入登录页'
				}
			]
		},
		{
			time:'2021/4/21',
			version:'2.4.2',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'优化勾选用户协议后下次还要勾选的问题'
				}
			]
		},
		{
			time:'2021/4/20',
			version:'2.4.1',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'新架构v2.0图片压缩通过width控制'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'使用记录拆分为记录状态，类型，模式'
				}
			]
		},
		{
			time:'2021/4/19',
			version:'2.4.0',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'登录，注册页面增加隐私政策及用户协议'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'平台管理-->增加ip白名单'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'新增基础设置-->姓名脱敏及手机号脱敏'
				},
			]
		},
		{
			time:'2021/3/17',
			version:'2.3.9',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'数据监控-->数据导出【增加数据导出页面】'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'多个message在同一位置弹出'
				},
			]
		},
		{
			time:'2021/3/16',
			version:'2.3.8',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'组织架构-->人员管理-->删除人员时无响应'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'我的个人信息编辑成功后提醒用户'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'还原之前2.3.7修改的【所属组织接口更换】'
				},
			]
		},
		{
			time:'2021/3/15',
			version:'2.3.7',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'图片浏览时点击[]后放大1.1倍'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'设备管理-->印章管理-->印章编辑【所属组织接口更换】'
				},
			]
		},
		{
			time:'2021/3/11',
			version:'2.3.6',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'会话失效后弹出信息太多影响美观'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'调节首页快捷方式弹出层宽度'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'组织架构-->人员管理-->编辑【所属组织可为空】'
				},
			]
		},
		{
			time:'2021/3/10',
			version:'2.3.5',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'平台管理-->增加小程序管理'
				},
			]
		},
		{
			time:'2021/3/3',
			version:'2.3.4',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'设备管理-->印章管理-->去除【绑定高拍仪】'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'平台管理-->印章配置管理-->功能去除弹出框的【确定与取消】'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'平台管理-->印章配置管理-->编辑-->去除切换版本'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'平台管理-->印章配置管理-->功能回显问题'
				},
			]
		},
		{
			time:'2021/3/2',
			version:'2.3.3',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'系统管理-->通知管理-->增加【批量关闭，开启】'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'平台管理-->服务功能设置-->增加【属主姓名,属主联系方式,注册时间】，并增加【关键词搜索】'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'登录界面-->短信验证码登录-->修复直接点击登录无提示信息'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复首页地图界面，无印章情况下地图始终加载中问题'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'设备管理-->印章管理-->用印记录-->备注【回显上个备注信息】'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'远程控制参数优化'
				},
			]
		},
		{
			time:'2021/2/25',
			version:'2.3.2',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'添加员工和删除员工之前检测手机号码是否注册过'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'系统管理-->远程控制【只有没开启申请单才能点击】'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'开启申请单，开启产测改为【1开启2关闭】'
				}
			]
		},
		{
			time:'2021/2/24',
			version:'2.3.1',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'平台管理-->印章管理配置-->增加功能选项（开启申请单，开启产测）'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'发送验证码输入框点击右侧没获取光标问题'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'摄像头开关指令位置转移-->由平台管理-印章管理配置-->转移到系统管理-远程控制'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'添加员工后，再次添加倒计时没有清除'
				},
			]
		},
		{
			time:'2021/2/22',
			version:'2.3.0',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'组织架构-->人员管理-->添加人员和编辑人员-->增加手机验证码'
				},
			]
		},
		{
			time:'2021/1/26',
			version:'2.2.9',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'平台管理-->印章管理配置-->增加摄像头开关'
				},
			]
		},
		{
			time:'2021/1/26',
			version:'2.2.8',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'首页-->地图印章数据分页加载'
				},
			]
		},
		{
			time:'2021/1/22',
			version:'2.2.7',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'平台管理-->印章管理-->log日志-->下载文件路径拼接改成后台设置'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'平台管理-->印章管理-->表格增加印章出厂日期'
				},
			]
		},
		{
			time:'2021/1/21',
			version:'2.2.6',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'登录界面-->备案号信息更新'
				},
			]
		},
		{
			time:'2021/1/18',
			version:'2.2.5',
			li:[
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'登录界面-->弱化注册功能在登录右下方，防止用户误操作'
				},
			]
		},
		{
			time:'2021/1/15',
			version:'2.2.4',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'用印中心-->申请用章-->审批人第一个为自己时没有弹出提示框'
				},
			]
		},
		{
			time:'2021/1/11',
			version:'2.2.3',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'组织架构-->人员管理-->搜索-->组织一级里面可以有多个公司'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'组织架构-->人员管理-->添加人员-->人员状态默认为正常'
				},
			]
		},
		{
			time:'2020/12/1---2020/12/3',
			version:'2.2.2',
			li:[
				{
					type:'',//warning/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复个人信息修改其他信息后头像不展示问题'
				},
				{
					type:'',//warning/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复上传附件检测文件大小'
				},
			]
		},
		{
			time:'2020/11/13---2020/11/18',
			version:'2.2.0',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'申请导出增加样式选择',
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'组织架构-->人员管理-->删除员工先删除员工拥有的设备指纹',
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'优化申请导出界面，选择更加明显，处理无图片，图片类型问题'
				},
				{
					type:'',//warning/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'组织名称限制字数15修改为30'
				},
			]
		},
		{
			time:'2020/11/06',
			version:'2.1.9',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'【用印中心-->使用记录-->增加作废记录功能】【设备管理-->印章管理-->使用记录-->增加作废记录功能】'
				},
			]
		},
		{
			time:'2020/11/03',
			version:'2.1.8',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'我的申请-->查看-->使用记录-->增加追加图片并显示上传人和上传时间'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'申请导出可以单项、多选、全部导出'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'印章管理-->申请导出-->参与人类型默认为空'
				},
			]
		},
		{
			time:'2020/10/30',
			version:'2.1.7',
			li:[
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'用印中心-->使用记录-->修复印章密码模式去除绑定申请单'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'修复审批流程中配置主管自选下一审批人时，当主管未指定下一审批人导致申请单无法走完流程问题'
				},
			]
		},
		{
			time:'2020/10/19-2020/10/23',
			version:'2.1.6',
			li:[
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'设备管理-->印章管理-->使用记录增加追加图片信息【包括导出记录增加追加图片】'
				},
				{
					type:'success',//success/''/warning||新增/优化/修复
					typeInfo:'新增',
					text:'印章的使用模式增加一项的密码模式'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'拆章报警不定时触发问题'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'导出使用记录为一页数据时页面无法导出问题'
				},
				{
					type:'warning',//success/''/warning||新增/优化/修复
					typeInfo:'修复',
					text:'刷新页面后退出登录后还请求其他接口，导致登录页出现错误警告弹出'
				},
				{
					type:'',//success/''/warning||新增/优化/修复
					typeInfo:'优化',
					text:'平台管理-->apk版本选取优化'
				},
			]
		},
		{
			time:'2020/10/14',
			version:'2.1.5',
			li:[
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'设备管理-->印章管理-->使用记录-->搜索日期为空时出现的问题'
			},
			]
		},
		{
			time:'2020/9/16',
			version:'2.1.4',
			li:[
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'设备管理-->印章管理-->增加【申请导出】'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'登录时增加【登陆中...】的遮罩等待'
			},
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'所有搜索功能默认展开【鲁总提出】'
			},
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'优化首页地图展示'
			},
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'设备管理-->印章管理-->使用记录-->搜索日期传参问题'
			},
			]
		},
		{
			time:'2020/9/16',
			version:'2.1.3',
			li:[
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'设备管理-->印章管理-->表格展开后【印章图片】不显示问题'
			}
			]
		},
		{
			time:'2020/9/11',
			version:'2.1.2',
			li:[
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'处理下切换公司退出账号后，提示信息【账号已登出，请重新登录】的问题'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'用印中心-->使用记录-->申请导出【弹出信息】'
			},
			]
		},
		{
			time:'2020/9/08 [新架构调整]',
			version:'2.1.1',
			li:[
			{
				type:'',//success/''/warning||新增/优化/修复
				typeInfo:'优化',
				text:'平台所有图片查看，都进行压缩优化通过width控制图片大小，支持查看原图无压缩'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'平台管理-->印章配置管理-->数据默认展示全平台公司所有印章、【迁移】增加迁移提示信息'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'平台管理-->印章配置管理-->增加离线消息'
			},
			]
		},
		{
			time:'2020/9/02',
			version:'2.1.0',
			li:[
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'根据等保测评要求，【账号登录接口中  手机号与密码、短信登录接口中  手机号和验证码、注册接口中  手机号和密码】都需要分别进行RSA加密'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'RSA加密版本需要在请求头中标记版本号yx_version'
			},
			]
		},
		{
			time:'2020/8/26',
			version:'2.0.9',
			li:[
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'路由模式去除#使用history模式'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'平台管理-->印章配置管理-->导出-->增加【业务服务器host，业务服务器IP】'
			},
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'用印中心-->使用记录-->增加【图片】导出打印pdf文件'
			},
			]
		},
		{
			time:'2020/8/21',
			version:'2.0.8',
			li:[
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'首页切换组织，会跳转到登录页面的bug'
			},
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'修复拆卸报警弹框-->点击查看时显示灰色背景，无弹框问题'
			},
			]

		},
		{
			time:'2020/8/06',
			version:'2.0.7',
			li:[
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'数据监控-->修复地图数据不显示'
			},
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'数据监控-->地图全屏和不全屏时路由菜单不显示问题'
			},
			]

		},
		{
			time:'2020/8/03',
			version:'2.0.6',
			li:[
			{
				type:'success',//success/''/warning||新增/优化/修复
				typeInfo:'新增',
				text:'设备管理-->印章管理-->指纹-->指纹录入增加规则校验【中文不能超过6个字符，英文不能超过12个字符】'
			},
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'审批管理-->[审批处理,授权处理，审计处理]-->表格申请日期字段【updateDate】修改为【createDate】'
			},
			]
		},
		{
			time:'2020/7/20',
			version:'2.0.5',
			li:[
			{
				type:'warning',//success/''/warning||新增/优化/修复
				typeInfo:'修复',
				text:'定时请求拆卸警告接口，在用户退出后，出现【账号已登出，请重新登录】的问题'
			},
			]

		},
]
export default versionArr



// WEBPACK FOOTER //
// ./src/utils/version.js